import React, { useRef } from 'react';
import DropdownList from 'atomic/dropdown-list';
import './product-offers-dropdown.scss';
import useOnClickOutside from 'hooks/use-onclick-outside';

interface ProductOffersDropdownProps {
    onBlur: (event: React.FocusEvent<HTMLElement>) => void;
    onToggle: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    isOpen: boolean;
    title?: string;
    dropdownList: { label: string; isActive: boolean; value: string; gtm: string; }[];
    value: string[];
    multi?: boolean;
    onSelect: (value: string) => void;
    onClose: () => void;
}

const ProductOffersDropdown: React.FC<ProductOffersDropdownProps> = props => {
    const ref = useRef(null);

    useOnClickOutside(ref, props.onClose);

    return (
        <div ref={ref} className="product-offers-dropdown" role="button">
            <button
                type="button"
                className={`product-offers-dropdown__button ${props.value.length > 0 && props.multi ? 'product-offers-dropdown__button--active' : ''}`}
                onClick={props.onToggle}
            >
                {props.children}
            </button>
            {props.isOpen && (<DropdownList
                title={props.title}
                list={props.dropdownList}
                value={props.value}
                onSelect={props.onSelect}
                multi={props.multi}
            />)}
        </div>
    );
};

export default ProductOffersDropdown;
